import { StatusBar, StatusBarStyle } from 'expo-status-bar'
import { observer } from 'mobx-react-lite'
import React, { useCallback } from 'react'
import { FlatList, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { Divider } from 'react-native-paper'

import { useFocusEffect, useRouter } from 'expo-router'

import { Text } from '../../components'
import { MainHeader } from '../../components/MainHeader/MainHeader'
import { PlayerHoleCards } from '../../components/PlayerHoleCards/PlayerHoleCards'
import { useStore } from '../../models'
import { styles } from './styles'

export const PlayHistoryScreen = observer(() => {
  const router = useRouter()
  // const [refreshing, setRefreshing] = React.useState(false)
  const store = useStore()
  const playHistoryData = store.game.playHistoryData

  useFocusEffect(
    useCallback(() => {
      const getGameHistory = async () => {
        try {
          await store.game.getGameHistory()
        } catch (error) {
          console.log('Get Player Games Error: ', error)
        }
      }
      getGameHistory()
    }, [store.game])
  )

  const goBack = () => {
    router.replace('/profile')
  }

  // const onRefresh = React.useCallback(() => {
  //   setRefreshing(true)
  //   setTimeout(() => {
  //     setRefreshing(false)
  //   }, 2000)
  // }, [])

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar animated={true} style={'dark' as StatusBarStyle} hidden={false} />
      <MainHeader
        leftPress={goBack}
        title={'Play History'}
        titleStyle={{ color: '#121212' }}
        headerContainerStyle={styles.headerContainerStyle}
      />
      <View style={[styles.playHistoryHeaderContainer, { paddingHorizontal: 24 }]}>
        <View style={styles.dateHeader}>
          <Text style={[styles.header, styles.playHistoryValue]}>DATE</Text>
        </View>
        <View style={styles.runTimeHeader}>
          <Text style={[styles.header, styles.playHistoryValue]}>RUNTIME</Text>
        </View>
        <View style={styles.handHeader}>
          <Text style={[styles.header, styles.playHistoryValue]}>Hands</Text>
        </View>
        <View style={styles.besthandHeader}>
          <Text style={[styles.header, styles.playHistoryValue]}>Best hand</Text>
        </View>
      </View>

      <FlatList
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{ paddingBottom: 50 }}
        data={playHistoryData}
        extraData={playHistoryData}
        keyExtractor={(item, index) => `play-histry-${index}`}
        renderItem={({ item, index }) => {
          //NOTE: runtime = hr:min:sec
          const runTime = `${Math.floor(item.timeDuration.hours)}:${Math.floor(item.timeDuration.minutes)}:${Math.floor(
            item.timeDuration.seconds
          )}`
          const gameDate = new Date(item.createdAt)
          const formattedDate = `${gameDate.getMonth() + 1}.${gameDate.getDate()}.${gameDate.getFullYear() % 100}`
          return (
            <View style={[styles.listValueContainer, { paddingHorizontal: 24 }]} key={index}>
              <View style={styles.valueContainer}>
                <Text style={styles.valueTextStyle}>{formattedDate}</Text>
              </View>
              <View style={styles.runValueContainer}>
                <Text style={styles.runtimeValueTextStyle}>{runTime}</Text>
              </View>
              <View style={styles.handValueContainer}>
                <Text style={styles.valueTextStyle}>{item.numberOfHands}</Text>
              </View>
              <View style={styles.playHoleCardValueContainer}>
                {item.bestHand ? (
                  <PlayerHoleCards
                    hand={item.bestHand.cards}
                    isFolded={false}
                    useFourColoredCardStyle={true}
                    customLeftCardStyle={styles.customLeftCardStyle}
                    customRightCardStyle={styles.customRightCardStyle}
                  />
                ) : (
                  <Text style={{ color: '#121212', fontSize: 16, textAlign: 'center' }}>--</Text>
                )}
              </View>
            </View>
          )
        }}
        ItemSeparatorComponent={() => {
          return <Divider style={{ marginHorizontal: 10 }} />
        }}
        style={[styles.playHistoryTableStyle, { marginTop: 0, borderRadius: 0 }]}
      />
    </SafeAreaView>
  )
})
